import { useCallback, useEffect, useState } from "react";
import Button from "../components/Button";
import Card from "../components/Card";
import Input from "../components/Input";
import Navbar from "../components/Navbar";
import Title from "../components/Title";
import { apiUrl } from "../utils/api";
import {
  getDaysInMonthFromInputValue,
  getJstCurrentMonthInputValue,
} from "../utils/jst";

function Login({setUser,setPage,}) {
  const [activeTab, setActiveTab] = useState("login");
  const [shopName, setShopName] = useState("");
  const [shopId, setShopId] = useState("");
  const [shopToken, setShopToken] = useState("");
  const [shopAuthenticated, setShopAuthenticated] = useState(false);
  const [employeeId, setEmployeeId] =useState("");
  const [password, setPassword] =useState("");
  const [loading, setLoading] =useState(false);
  const [changeEmployeeId,setChangeEmployeeId] = useState("");
  const [currentPassword,setCurrentPassword] = useState("");
  const [newPassword,setNewPassword] = useState("");
  const [shiftMonth, setShiftMonth] = useState(getJstCurrentMonthInputValue);
  const [shiftHalfMode, setShiftHalfMode] = useState("first");
  const [monthlyShifts, setMonthlyShifts] = useState([]);
  const [shiftLoading, setShiftLoading] = useState(false);
  const thStyle = {border: "1px solid #ccc",padding: "8px",background: "#f3f4f6",};
  const tdStyle = {border: "1px solid #ccc",padding: "8px",textAlign: "center",};
  const shiftTableStyle = {
    width: "max-content",
    minWidth: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    fontSize: "12px",
  };
  const shiftTableWrapStyle = {
    overflow: "auto",
    marginTop: "10px",
    maxHeight: "min(58vh, 420px)",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    background: "#fff",
  };
  const stickyNameHeaderStyle = {
    ...thStyle,
    position: "sticky",
    top: 0,
    left: 0,
    zIndex: 5,
    minWidth: "120px",
    background: "#f3f4f6",
    boxShadow: "1px 0 0 #d1d5db",
    backgroundClip: "padding-box",
  };
  const stickyDayHeaderStyle = {
    ...thStyle,
    position: "sticky",
    top: 0,
    zIndex: 4,
    background: "#f3f4f6",
    backgroundClip: "padding-box",
  };
  const stickyNameCellStyle = {
    ...tdStyle,
    position: "sticky",
    left: 0,
    zIndex: 2,
    minWidth: "120px",
    background: "#fff",
    boxShadow: "1px 0 0 #d1d5db",
    backgroundClip: "padding-box",
  };

  const daysInMonth = getDaysInMonthFromInputValue(shiftMonth);
  const displayDays =
    shiftHalfMode === "first"
      ? [...Array(15)].map((_, index) => index + 1)
      : [...Array(daysInMonth - 15)].map((_, index) => index + 16);

  const shiftUsers = monthlyShifts.reduce((list, shift) => {
    if (!list.some((user) => Number(user.id) === Number(shift.user_id))) {
      list.push({
        id: shift.user_id,
        name: shift.name,
      });
    }
    return list;
  }, []);

  const fetchMonthlyShifts = useCallback(async () => {
    try {
      setShiftLoading(true);
      if (!shopId) {
        setMonthlyShifts([]);
        return;
      }
      const res = await fetch(
        apiUrl(`/public-shifts?month=${shiftMonth}&shopId=${encodeURIComponent(
          shopId
        )}`)
      );
      const data = await res.json();
      if (!res.ok) {
        setMonthlyShifts([]);
        return;
      }
      setMonthlyShifts(data);
    } catch (error) {
      console.error(error);
      setMonthlyShifts([]);
    } finally {
      setShiftLoading(false);
    }
  }, [shiftMonth, shopId]);

  const restoreShopSession = () => {
    const storedShopToken = localStorage.getItem("shopToken");
    const storedShopId = localStorage.getItem("shopId");
    const storedShopName = localStorage.getItem("shopName");
    if (storedShopToken && storedShopId && storedShopName) {
      setShopToken(storedShopToken);
      setShopId(storedShopId);
      setShopName(storedShopName);
      setShopAuthenticated(true);
    }
  };

  useEffect(() => {
    fetchMonthlyShifts();
  }, [fetchMonthlyShifts]);

  useEffect(() => {
    restoreShopSession();
  }, []);

  useEffect(() => {
    setShiftHalfMode("first");
  }, [shiftMonth]);

  // =========================
  // ログイン
  // =========================
  const handleLogin = async () => {
    if (!shopAuthenticated || !shopToken) {
      alert("店舗ログインしてください");
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(apiUrl("/login"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-shop-token": shopToken,
        },
        body: JSON.stringify({
          employeeId,
          password,
        }),
      });
      const data = await res.json();
      // ログイン失敗
      if (!res.ok) {
        alert(data.message);
        return;
      }
      // token保存
      localStorage.setItem("token", data.token);
      // user保存
      localStorage.setItem("user", JSON.stringify(data.user));
      setUser(data.user);
    } catch (error) {
      console.error(error);
      alert("ログインエラー");
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // パスワード変更
  // =========================
  const handleChangePassword =
  async () => {
    if (!shopAuthenticated) {
      alert("店舗ログインしてください");
      return;
    }
    try {
	      const res = await fetch(
	        apiUrl("/change-password"),
        {
          method: "PUT",
          headers: {"Content-Type":"application/json",},
          body: JSON.stringify({
            employeeId:
            changeEmployeeId,
            currentPassword,
            newPassword,
          }),
        }
      );

      const data = await res.json();
      alert(data.message);
      if (res.ok) {
        setActiveTab("login");
        setChangeEmployeeId("");
        setCurrentPassword("");
        setNewPassword("");
      }
    } catch (error) {
      console.error(error);
    }
  };
  // =========================
  // 表示
  // =========================
	  return (
	    <div>
	      <Navbar />
	      <main className="page-shell" style={{ maxWidth: "1120px", }}>
	      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(300px, 100%), 1fr))", gap: "20px", alignItems: "start", }}>
	      <Card className="p-5 sm:p-6">
	      <Title>{activeTab === "login" ? "ログイン" : "パスワード変更"}</Title>
	      <p style={{ margin: "0 0 18px", color: "#64748b", fontSize: "14px", }}>
        従業員ログインには事前に店舗ログインが必要です。
      </p>
	      <p style={{ margin: "0 0 18px", color: "#334155", fontSize: "14px" }}>
        先に店舗ログインページへ進んでください。
      </p>
      <div style={{ marginBottom: "18px", padding: "16px", border: "1px solid #e2e8f0", borderRadius: "12px", background: "#f8fafc", }}>
        {!shopAuthenticated ? (
          <Button size="full" onClick={() => setPage("shop-login")}>
            店舗ログインへ
          </Button>
        ) : (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
            <div>
              <p style={{ margin: 0, color: "#334155", fontSize: "14px", fontWeight: 700 }}>
                現在の店舗
              </p>
              <p style={{ margin: "4px 0 0", color: "#475569", fontSize: "14px" }}>
                {shopName}
              </p>
            </div>
            <Button color="light" size="sm" onClick={() => setPage("shop-login")}>
              店舗切替
            </Button>
          </div>
        )}
      </div>
      <div style={{display: "flex",gap: "6px",marginBottom: "18px", padding: "4px", border: "1px solid #e2e8f0", borderRadius: "8px", background: "#f8fafc",}}>
	        <button onClick={() => setActiveTab("login")} className={`flex-1 px-4 py-2 text-sm font-semibold rounded-lg ${activeTab === "login" ? "bg-blue-600 text-white" : "text-gray-600 hover:bg-gray-100"}`}>ログイン</button>
	        <button onClick={() => setActiveTab("password")} className={`flex-1 px-4 py-2 text-sm font-semibold rounded-lg ${activeTab === "password" ? "bg-blue-600 text-white" : "text-gray-600 hover:bg-gray-100"}`}>PW変更</button>
	      </div>
	      {activeTab === "login" ? (
	        <div style={{ display: "grid", gap: "12px" }}>
            <label style={{ fontSize: "13px", fontWeight: 700, color: "#334155", }}>
              従業員ID
	          <Input className="mt-1 w-full" type="text" placeholder="例: 1001" value={employeeId} onChange={(e) => setEmployeeId( e.target.value)}/>
            </label>
            <label style={{ fontSize: "13px", fontWeight: 700, color: "#334155", }}>
              パスワード
	          <Input className="mt-1 w-full" type="password" placeholder="パスワード" value={password} onChange={(e) => setPassword(e.target.value)}
	            onKeyDown={(e) => {
	              if (e.key === "Enter") {
	                handleLogin();
	              }
	            }}/>
            </label>
	          <Button size="full" onClick={handleLogin} disabled={loading || !shopAuthenticated}>
            {loading ? "ログイン中..." : "ログイン"}
          </Button>
	        </div>
	      ) : (
	        <div style={{ display: "flex", flexDirection: "column", gap: "12px",}}>
	          <Input className="w-full" type="text" placeholder="従業員ID" value={changeEmployeeId} onChange={(e) => setChangeEmployeeId( e.target.value)}/>
	          <Input className="w-full" type="password" placeholder="現在のパスワード" value={currentPassword} onChange={(e) => setCurrentPassword( e.target.value)}/>
	          <Input className="w-full" type="password" placeholder="新しいパスワード" value={newPassword} onChange={(e) => setNewPassword( e.target.value)}/>
	          <Button size="full" onClick={ handleChangePassword }>変更する</Button>
	        </div>
	      )}
	      </Card>
	      <Card className="p-5">
	      <div>
	        <div style={{ display: "flex", justifyContent: "space-between", gap: "12px", alignItems: "center", flexWrap: "wrap", marginBottom: "12px" }}>
            <div>
	        <h2 style={{ margin: 0, fontSize: "20px", fontWeight: 800, }}>月別シフト表</h2>
            <p style={{ margin: "4px 0 0", color: "#64748b", fontSize: "13px" }}>確定済みの公開シフトを確認できます。</p>
            </div>
	        <Input
	          className="w-auto mb-0"
	          type="month"
	          value={shiftMonth}
	          onChange={(e) => setShiftMonth(e.target.value)}
	        />
          </div>
	        <div className="toolbar-scroll" style={{marginTop: "6px",marginBottom: "10px",}}>
	          <Button color={shiftHalfMode === "first" ? "blue" : "light"} size="auto" onClick={() => setShiftHalfMode("first")}>前半</Button>
	          <Button color={shiftHalfMode === "second" ? "blue" : "light"} size="auto" onClick={() => setShiftHalfMode("second")}>後半</Button>
	        </div>
        {shiftLoading ? (
          <p>読み込み中...</p>
        ) : shiftUsers.length === 0 ? (
          <p>この月の確定シフトはありません</p>
        ) : (
	          <div className="table-scroll" style={shiftTableWrapStyle}>
	            <table style={shiftTableStyle}>
	              <thead>
	                <tr>
	                  <th style={stickyNameHeaderStyle}>従業員</th>
	                  {displayDays.map((day) => (
	                    <th key={day} style={{...stickyDayHeaderStyle,minWidth: "80px",}}>{day}</th>
	                  ))}
                </tr>
              </thead>
              <tbody>
                {shiftUsers.map((user) => (
                  <tr key={user.id}>
                    <td style={stickyNameCellStyle}>{user.name}</td>
                    {displayDays.map((day) => {
                      const shift = monthlyShifts.find((item) => {
                        const shiftDay = Number(String(item.date).slice(8, 10));
                        return Number(item.user_id) === Number(user.id) && shiftDay === day;
                      });
                      return (
                        <td key={day} style={{...tdStyle,minWidth: "80px",}}>
                          {shift ? `${shift.start_time?.slice(0,5)}〜${shift.end_time?.slice(0,5)}` : "-"}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
	        )}
	      </div>
	      </Card>
	      </div>
	      </main>
	    </div>
	  );
}

export default Login;
